export default __webpack_public_path__ + "static/media/arrow_right.e090a287.svg";